import React, { useState } from 'react'
import EmployeeModal from '../modals/employesModal'

type Props = {
  data: any
  position: number
}

export default function UserInfoTab({ data, position }: Props) {
  const [modalOpen, setModalOpen] = useState(false);
  let type = localStorage.getItem("usertype")
  const closeModal = (value: any) => {
    setModalOpen(false)
  }
  //console.log('data', data)
  return (
    <>
      <defs>
        <rect
          id={position + 'rect'}
          width="40px"
          height="40px"
          x={position <= 2 ? -160 : 10}
          y={position <= 2 ? (25 + position * 47) : (25 + (position - 2) * 47)}
          rx="50"
          stroke="none"
        />
        <clipPath id={'clip' + position}>
          <use xlinkHref={'#' + position + 'rect'} />
        </clipPath>
      </defs>
      <use
        xlinkHref={'#' + position + 'rect'}
        strokeWidth=".5"
        fill="#c6c6c6"
        y={'0px'}
        stroke="none"
      />

      <image
        //xlinkHref={data?.url[`Avatar${data?.id - 1}`]}
        xlinkHref={typeof data?.photo == 'string' ? data?.photo : ''}
        x={position <= 2 ? -160 : 10}
        y={position <= 2 ? (25 + position * 47) : (25 + (position - 2) * 47)}
        width="40px"
        height="40px"
        clipPath={'url(#clip' + position + ')'}
      />

      <foreignObject
        //onClick={addSourceBtnCLickHandler}
        className="user-name"
        y={position <= 2 ? (25 + position * 47) : (25 + (position - 2) * 47)}
        x={position <= 2 ? -110 : 60}
        width={data.title ? 160 : 130}
        height="50"
        fontSize={15}
        fontFamily="Arial"
        style={{ pointerEvents: 'none' }}
        color={'black'}
      >
        {data?.last_name ? ' ' + data?.last_name?.toString().substring(0, 30) : data?.name?.toString().substring(0, 30)}
        {data?.first_name && ' ' + data?.first_name?.toString().substring(0, 30)}
        {data?.patronymic && ' ' + data?.patronymic?.toString().substring(0, 30)}
      </foreignObject>
      {(
        <foreignObject
          y={position <= 2 ? (57 + position * 47) : (40 + (position - 2) * 47)}
          x={position <= 2 ? -110 : 60}
          width={data.title ? 250 : 130}
          height="50"
          fontSize={10}
          fontFamily="Arial"
          style={{ pointerEvents: 'none' }}
          color={'grey'}
        >
          {data?.subs?.toLocaleString()}
          {data?.post?.toLocaleString()}
        </foreignObject>
      )}

      {type == "industry" && <image
        //xlinkHref={data?.url[`Avatar${data?.id - 1}`]}
        onClick={() => setModalOpen(true)}
        xlinkHref="/settings.png"
        x={position <= 2 ? -170 : 0}
        y={position <= 2 ? (20 + position * 47) : (20 + (position - 2) * 47)}
        width="18px"
        height="18px"
        clipPath={'url(#clip2' + position + ')'}
      />}
      <EmployeeModal open={modalOpen} isCloseModal={closeModal} user={data}/>
    </>
  )
}
